// @flow
import { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import SimpleDate from 'app/dataProviders/SimpleDate';
import { api } from 'app/api';
import { GET_DAY, convertResult, convertParams } from 'app/common/api/requests/cabinet/dnevnik/day';
import type { ScheduleDay } from 'app/dataTypes/ScheduleDay.types';


type Params = {
  studentId: string,
  klassId: string | null,
  date: SimpleDate,
}

const defaultDaySchedule: ScheduleDay = [];

export default function useScheduleDayData({ klassId, studentId, date }: Params): [ScheduleDay, boolean] {
  const { t } = useTranslation('app');
  const [day, setDay] = useState<ScheduleDay>(defaultDaySchedule);
  const [loading, setLoading] = useState(true);

  const request = useCallback(async () => {
    setLoading(true);
    const res = await api.request(GET_DAY, {
      error: t('request_dnevnik_failed'),
      params: { klassId, studentId, date },
      convertions: { convertParams, convertResult },
    });
    if (res) {
      setDay(res);
    }
    setLoading(false);
  }, [klassId, studentId, date, t]);

  useEffect(() => {
    request();
  }, [request]);

  return [day, loading];
}
